export default __webpack_public_path__ + "static/media/deliland-brownsugar-icon.c246a550.png";